const normalizeCredentialPart = (value) => String(value || "").trim();

/**
 * Resolve the authorization header for first-party account requests.
 *
 * A signed-in account token is authoritative. API-key fallback is allowed only
 * when the key is paired with its own apiUserName cookie; the account username
 * must never be combined with an unrelated, previously selected API key.
 */
const resolveStoredAuthorization = (getCookie) => {
  const token = normalizeCredentialPart(getCookie("token"));
  if (token) return `Bearer ${token}`;

  const apiUserName = normalizeCredentialPart(getCookie("apiUserName"));
  const apiKey = normalizeCredentialPart(getCookie("apiKey"));
  if (apiUserName && apiKey) return `Bearer ${apiUserName}:${apiKey}`;

  return "";
};

const buildStoredAuthorizationHeaders = (getCookie) => {
  const authorization = resolveStoredAuthorization(getCookie);
  return authorization ? { Authorization: authorization } : {};
};

module.exports = {
  resolveStoredAuthorization,
  buildStoredAuthorizationHeaders,
};
